import React, { useState } from "react";
import { TextareaAutosize, Typography } from "@mui/material";
import UserFilter from "../UserFilter/UserFilter";
import { t } from "i18next";
import CoreButton from "../CoreButton/CoreButton";
import { useRequestServiceMutation } from "../../../../features/api/admin/ServiziApi";
import { toast } from "react-toastify";
import { useGetUsersQuery } from "../../../../features/api/admin/gestisciUtentiApi";
import { useRequestUserServiceMutation } from "../../../../features/api/user/altriServiziApi";
import { useSelector } from "react-redux";
import { ROLE } from "../../../../utils/constants/profiles";

const CoreRequestServices = ({ selectedService, onClose }) => {
  const appState = useSelector((state) => state.app);

  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [requestDescription, setRequestDescription] = useState("");

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery(
    {
      page: { startRow: 0, endRow: 50 },
      value: debouncedInputUserValue,
    },
    { refetchOnMountOrArgChange: true, skip: appState.role === ROLE.USER }
  );

  const [requestService, { isLoading: isRequestingService }] =
    useRequestServiceMutation();

  const [requestUserService, { isLoading: isUserRequestingService }] =
    useRequestUserServiceMutation();

  const handleSuggestService = () => {
    const body = {
      serviceId: selectedService.id,
      userId: selectedUser?.id,
      description: requestDescription.trim() || null,
    };
    if (appState.role === ROLE.USER) delete body.userId;
    (appState.role === ROLE.USER
      ? requestUserService(body)
      : requestService(body)
    )
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("RequestNotSent"));
          return;
        }
        toast.success(t("RequestSent"));
        onClose();
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("RequestNotSent"));
      });
  };

  return (
    <div className="p-4 h-5/6 flex flex-col justify-between items-center">
      <h2>{t("ServiceRequestForUser")}</h2>
      <div className="w-full mb-12">
        {appState.role !== ROLE.USER && (
          <UserFilter
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            usersList={usersData?.Data?.items}
            setDebouncedInputUserValue={setDebouncedInputUserValue}
            isUsersLoading={isUsersLoading || isUsersFetching}
          />
        )}

        <div className="w-full flex flex-col justify-start mt-5">
          <div className="flex">
            <Typography variant="body2" gutterBottom>
              {t("Service")}
            </Typography>
            <Typography>&nbsp;</Typography>
            <Typography
              variant="body2"
              gutterBottom
              className="text-green-600 font-semibold"
            >
              {`${selectedService?.name || selectedService?.Nome}`}
            </Typography>
          </div>
          <div className="flex">
            <Typography variant="body2" gutterBottom>
              {t("User")}
            </Typography>
            <Typography>&nbsp;</Typography>
            <Typography
              variant="body2"
              gutterBottom
              className={
                selectedUser || appState.role === ROLE.USER
                  ? "text-green-600 font-semibold"
                  : "italic"
              }
            >{`${
              appState.role === ROLE.USER
                ? appState.name + " " + appState.surname
                : selectedUser
                ? selectedUser?.name + " " + selectedUser?.surname
                : `${t("SelectUser")}`
            }`}</Typography>
          </div>
        </div>
        <TextareaAutosize
          className="w-full text-base resize-none mt-5 rounded-lg shadow-sm p-2 font-sans text-md border border-solid border-lightgray"
          minRows={4}
          style={{ overflow: "auto", maxHeight: 120 }}
          placeholder={t("RequestDescriptionPlaceholder")}
          value={requestDescription}
          onChange={(e) => setRequestDescription(e.target.value)}
        />
      </div>
      <Typography variant="subtitle2" gutterBottom>
        {`${t("ServiceRequestForUserExt")}`}
      </Typography>
      <div>
        <CoreButton
          testo={
            isRequestingService || isUserRequestingService
              ? t("Wait")
              : t("Send")
          }
          className="btn-round"
          onClick={handleSuggestService}
          disabled={
            (!selectedUser && appState.role !== ROLE.USER) ||
            isRequestingService ||
            isUserRequestingService
          }
        />
      </div>
    </div>
  );
};

export default CoreRequestServices;
